export default "__VITE_ASSET__D5wxUCEJ__"